import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

/*
 * Title: Using to style top !important
 * problem: we do not want to use !important but we want a modal and a modal is expected to cover the entire screen
 * in this case however, material UI probably assumes you'll have the entire screen covered and uses inline styles
 * to define this behaviour. But here the modal as it is the case of next, partially exposes the header area hence it
 * does not fully cover the entire screen.
 * Solution: for now we have to use !important
 * Refs:
 *    https://github.com/mui-org/material-ui/issues/16441
 *    https://github.com/mui-org/material-ui/issues/16442
 */

type WrapperProps = {
    mobileHeight: number
    desktopHeight: number
}

export const Wrapper = styled("div", {
    shouldForwardProp: p => p !== "mobileHeight" && p !== "desktopHeight",
})<WrapperProps>`
    & > div {
        position: absolute !important;
        right: auto !important;
        left: auto !important;
        top: 3px !important;
        bottom: auto !important;
        width: 100%;

        & > div:first-of-type {
            top: 3rem;
            background: ${({theme}) => theme.uxfabric.components.menu.searchMenu.default.backgroundColor};
            opacity: 0 !important;
        }

        @media (min-width: ${breakpoints.values.md}px) {
            & > div:first-of-type {
                top: ${props => props.mobileHeight}rem !important;
            }
        }

        @media (min-width: ${breakpoints.values.lg}px) {
            & > div:first-of-type {
                top: ${props => props.desktopHeight}rem !important;
            }
        }
    }
`
